import { PageBlock, Stack } from 'braid-design-system';

import { HeaderBanner } from 'src/views/PackagesPage/components/HeaderBanner';
import { PackagesPageSections } from 'src/views/PackagesPage/components/PackagesPageSections';

const ProductsTab = () => (
  <Stack space="xxlarge">
    <HeaderBanner />

    <PageBlock width="large">
      <PackagesPageSections />
    </PageBlock>
  </Stack>
);

export default ProductsTab;
